module.exports = __webpack_public_path__ + "static/media/02.Bhaskar Kogga Kamath with Puppet.dc4738b2.jpg";